import Types from "../action/types"

export function component(state = {}, action = {}) {
    switch (action.type){

        case Types.FULL_PAGE_LOADER:{
            const {showFullPageLoading,opacity} = action.payload;
            return {
                ...state,showFullPageLoading,opacity
            }
        }
        case Types.SHOW_TOAST:{
            const {duration, text, anchorOrigin, variant} = action.payload;
            return {
                ...state, duration, text, anchorOrigin, variant, showToast:true
            }
        }
        case Types.HIDE_TOAST:{
            return {
                ...state, text:null, anchorOrigin:null, variant:null, showToast:false, duration:null
            }
        }
        case Types.TOGGLE_DRAWER:{
            return {...state, drawerOpen:action.payload.drawerOpen};
        }
        case Types.SHOW_POPUP: {
            const {renderComponent,showPopup,fullScreen} = action.payload;
            const popupState = state["popupState"] || {};
            return {
                ...state,
                popupState: {...popupState,renderComponent,showPopup,fullScreen}
            };
        }
        case Types.HIDE_POPUP:{
            const popupState = state["popupState"] || {};
            return {
                ...state,
                popupState: {...popupState, renderComponent: null,showPopup:false}
            };
        }
        default:
            return state
    }
}





// WEBPACK FOOTER //
// ./src/store/reducer/component.js